// extracted by mini-css-extract-plugin
export default {"companiesSecWrap":"CompanySearchSection_companiesSecWrap__ioj3i","companiesSecInner":"CompanySearchSection_companiesSecInner__6-lQA"};